export default __webpack_public_path__ + "static/media/EditActive.3f31c66c.svg";